export class CashInvestmentResultDto {
  glaccountNo: string;
  endingBalance: number;
  percentage: number;
  title: string;
}
